import BaseApiClient from "./base-client";
import { useContext } from "@/store/context";
class UsersApi extends BaseApiClient {
    DISCUSSIONS_USERS_BASE_PATH = "/api/discussions/users";
    STUDY_USERS_BASE_PATH = "/api/studies";
    getUserById = async ({ userId }, studyId) => {
        // Get the user from the provided studyId or the current studyId from context. If neither is available, fetch the user without a study context.
        const targetStudyId = studyId ?? useContext().currentStudyId;
        return this.get(`${this.getEndpoint(targetStudyId)}/${userId}`);
    };
    getUsers = async (userIds, studyId) => {
        const targetStudyId = studyId ?? useContext().currentStudyId;
        const endpoint = this.getEndpoint(targetStudyId);
        return this.get(`${endpoint}`, {
            params: { userIds }
        });
    };
    getUsersForStudy = async (studyId) => {
        return this.get(`${this.getEndpoint(studyId)}`);
    };
    getEndpoint = (studyId) => {
        return studyId ? `${this.STUDY_USERS_BASE_PATH}/${studyId}/users` : this.DISCUSSIONS_USERS_BASE_PATH;
    };
    static instance = new UsersApi();
}
export default UsersApi.instance;
